import { formatIst } from "./formatIst";

const ACTION_LABEL = { sent_back: "Sent Back", director_edit: "Director Edit", posted_edit: "Edit", completed_edit: "Edit" };

// Permanent, append-only change log rows (newest first). Read-only — no role
// can edit or delete these.
export function ChangeLogEntries({ history }) {
  return (
    <div className="space-y-2">
      {[...(history || [])].reverse().map((e, i) => (
        <div key={i} className="rounded-md border border-slate-200 p-2.5" data-testid={`line-history-entry-${i}`}>
          <div className="flex justify-between items-center gap-2">
            <p className="text-xs font-semibold text-slate-700">
              {ACTION_LABEL[e.action] || e.action} — {e.field}
            </p>
            <p className="text-[10px] text-slate-400 whitespace-nowrap">{formatIst(e.changed_at)}</p>
          </div>
          <p className="text-xs text-slate-500 mt-1">
            {e.changed_by_name} · {e.old_value ?? "—"} → {e.new_value ?? "—"}
          </p>
          {e.reason && <p className="text-xs text-slate-600 mt-1 italic" data-testid={`line-history-reason-${i}`}>Reason: {e.reason}</p>}
        </div>
      ))}
    </div>
  );
}

// Expandable change log shown on the entry itself, with Updated By / At.
export function ChangeLog({ entity, testId = "change-log" }) {
  const history = entity?.edit_history || [];
  return (
    <details className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2" data-testid={testId}>
      <summary className="cursor-pointer text-sm font-medium text-slate-700" data-testid={`${testId}-toggle`}>
        Change log ({history.length})
        {entity?.updated_by_name && (
          <span className="ml-2 text-xs font-normal text-slate-500" data-testid={`${testId}-updated`}>
            Updated by {entity.updated_by_name} · {formatIst(entity.updated_at)}
          </span>
        )}
      </summary>
      <div className="mt-2 max-h-56 overflow-y-auto">
        {history.length === 0 ? (
          <p className="text-xs text-slate-400 py-2">No changes recorded.</p>
        ) : (
          <ChangeLogEntries history={history} />
        )}
      </div>
    </details>
  );
}
